import { jsx as t } from "react/jsx-runtime";
import * as i from "@radix-ui/react-toggle-group";
import { b as l } from "./IconWinter-Cw_oV_Tf.js";
import { B as d } from "./useNotification-CLP1T-La.js";
var g = "_11nxehy0 _1uip08t0", p = { standard: "_11nxehy1", large: "_11nxehy2" };
function s({
  children: r,
  onValueChange: a,
  size: e = "standard",
  data: u,
  ...o
}) {
  return /* @__PURE__ */ t(
    i.Root,
    {
      ...l({ data: u, validateRestProps: o }),
      ...o,
      onValueChange: (n) => {
        n !== "" && a(n);
      },
      type: "single",
      asChild: !0,
      children: /* @__PURE__ */ t(
        d,
        {
          className: p[e],
          display: "flex",
          backgroundColor: "neutral-alternate",
          borderRadius: "8",
          children: r
        }
      )
    }
  );
}
s.displayName = "SegmentedControl";
function m({ children: r, data: a, ...e }) {
  return /* @__PURE__ */ t(
    i.Item,
    {
      ...l({ data: a, validateRestProps: e }),
      ...e,
      asChild: !0,
      children: /* @__PURE__ */ t(
        d,
        {
          className: g,
          as: "button",
          role: "radio",
          color: "neutral-alternate",
          cursor: "pointer",
          backgroundColor: "neutral-alternate",
          flexGrow: "1",
          paddingX: "4",
          borderWidth: "1",
          fontWeight: "medium",
          borderRadius: "8",
          children: r
        }
      )
    }
  );
}
m.displayName = "SegmentedControl.Item";
const h = Object.assign(s, { Item: m });
export {
  h as S
};
//# sourceMappingURL=SegmentedControl-CLhKlEBq.js.map
